import { css, SimpleInterpolation, ThemeProps } from 'styled-components';
import { Font, Theme } from '../../theme';

/*  One of the effects of using & { ... } styling in styled components is that the styling is added later 
    in the stylesheet. For example, if we have:

    ```
    const styledDiv = styled.div`
      ${styleA};

      & { 
        ${styleB};
      }
    `;
    ```

    then we will see, in the style tag:

    ```
    .styled-div { ${styledA} };
    .styled-div { ${styledB} };
    ```

    Therefore, applying this to the address card, we see:

    ```
    .styled-div { font-paragraph };
    @media screen and (min-width:600px) {.styled-div { font-paragraph }};
    .styled-div { font-paragraph-large };
    ```
    
    As the media-query doesn’t affect specificity, this means that we override the font for all breakpoints.
*/
const fontForLabel = (label: Font) => ({
  theme,
}: ThemeProps<Theme>): SimpleInterpolation =>
  css`
    & {
      ${theme.fonts[label]}
    }
  `;

type Fonts = {
  [T in Font]: ({ theme }: ThemeProps<Theme>) => SimpleInterpolation;
};

const fonts: Fonts = {
  headingXLarge: fontForLabel('headingXLarge'),
  headingLarge: fontForLabel('headingLarge'),
  headingMedium: fontForLabel('headingMedium'),
  headingSmall: fontForLabel('headingSmall'),
  headingXSmall: fontForLabel('headingXSmall'),
  paragraphLarge: fontForLabel('paragraphLarge'),
  paragraph: fontForLabel('paragraph'),
  paragraphSmall: fontForLabel('paragraphSmall'),
  paragraphStyled: fontForLabel('paragraphStyled'),
};

export default fonts;
